(() => {
    if (document.body.classList.contains('single-nr_redefine_item')) {
        new ScrollDown(document.body);
        new BGShape(document.body);

        imagesLoaded(document.querySelector('.jsMasonryGrid'), () => {
            initMasonry();
        });
    }

    function initMasonry() {
        const grid = document.querySelector('.jsMasonryGrid');
        const masonry = new Masonry(grid, { itemSelector: '.jsGridItem' });
        setTimeout(_ => masonry.layout(), 200);
    }
})();